import ChevronUpSvg from '@assets/images/svg/chevron-up.svg';
import React from 'react';
import { View } from 'react-native';

export interface ChevronUpIconProps {
    size?: number;
    color?: string;
}

export function ChevronUpIcon({ size = 24, color = '#333333' }: ChevronUpIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ChevronUpSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ChevronUpIcon;
